/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierPropertiesInput
 */
export interface CarrierPropertiesInput {
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesInput
   */
  carrierPropertiesId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesInput
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPropertiesInput
   */
  auditAgent?: string | null;
}

/**
 * Check if a given object implements the CarrierPropertiesInput interface.
 */
export function instanceOfCarrierPropertiesInput(
  value: object,
): value is CarrierPropertiesInput {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  return true;
}

export function CarrierPropertiesInputFromJSON(
  json: any,
): CarrierPropertiesInput {
  return CarrierPropertiesInputFromJSONTyped(json, false);
}

export function CarrierPropertiesInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierPropertiesInput {
  if (json == null) {
    return json;
  }
  return {
    carrierPropertiesId:
      json["carrierPropertiesId"] == null
        ? undefined
        : json["carrierPropertiesId"],
    carrierIdentifier: json["carrierIdentifier"],
    auditAgent: json["auditAgent"] == null ? undefined : json["auditAgent"],
  };
}

export function CarrierPropertiesInputToJSON(
  json: any,
): CarrierPropertiesInput {
  return CarrierPropertiesInputToJSONTyped(json, false);
}

export function CarrierPropertiesInputToJSONTyped(
  value?: CarrierPropertiesInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierPropertiesId: value["carrierPropertiesId"],
    carrierIdentifier: value["carrierIdentifier"],
    auditAgent: value["auditAgent"],
  };
}
